module.exports = __webpack_public_path__ + "static/media/clockwork.ff9a5f2d.png";